import script from "./TransactionInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionInfo.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionInfo.vue?vue&type=style&index=0&id=1c62e676&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c62e676"]])

export default __exports__